import { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ORDER_STATUS_CONSTANTS } from '../SampleReport/FormConstant';
import IconPen from '../../components/Icon/IconPen';
import IconPlus from '../../components/Icon/IconPlus';
import IconTrash from '../../components/Icon/IconTrash';
import IconSampleLabel from '../../components/Icon/IconSampleLabel';
import IconShipment from '../../components/Icon/IconShipment';
import { SEARCH_SAMPLE_PATH } from '../../routes';
import DeleteConfirmModal from './DeleteConfirmModal';
import IconPdf from '../../components/Icon/IconPdf';
import IconInformation from '../../components/Icon/IconInformation';
import IconBack from '../../components/Icon/IconBack';
import IconAddManuel from '../../components/Icon/IconAddManuel';

const DashboardTableData = ({
    data,
    orderStatusHandleFunction,
    currentStatus,
    orderDeleteHandleFunction,
    orderEditHandleFunction,
    createShipmentLabelFunction,
    createManuelShipmentLabelFunction,
    currentPage,
    dataSize,
    requestDataFunction,
    requestOnlyPdfFunction,
    requestGeneralLabel,
    pdfUsedHandleFunction,
   }) => {
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isDeleteModalData, setIsDeleteModalData] = useState({});
    const navigate = useNavigate();
    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString();
    };
    const itemsPerPage = 5;

    // Calculate pagination
    const totalPages = Math.ceil(dataSize / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    const endIndex = Math.min(startIndex + itemsPerPage - 1, dataSize);

    const handleDeleteConfirmModalOpen = (orderId) => {
        setIsDeleteModalData({
            orderId
        })
        setIsDeleteModalOpen(true);
    }

    const acceptDelete = (orderId) => {
        orderDeleteHandleFunction(currentStatus, orderId);
    }

    return (
        <>
            {data.map((order, orderIndex) => (
                <div className="flex flex-row w-full h-auto text-xs pt-1">
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white">
                        <h2 className="text-center">SA_{order.orderId}{order.isRevised ? 'R' : ''}</h2>
                    </div>
                    <div className="w-[30%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white whitespace-pre-line">
                        <h2 className="text-center">{order.formData.customerName} {order.formData.projectName}</h2>
                    </div>
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white">
                        <h2 className="text-center">{formatDate(order.created_at)}</h2>
                    </div>
                    <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white">
                        {(currentStatus === 'Shipping' || currentStatus === 'Completed') &&
                            <h2 className="p-2">{currentStatus}</h2>
                        }
                        {currentStatus !== 'Shipping' && currentStatus !== 'Completed' &&
                            <select id="orderStatus"
                                    value={order.status}
                                    className="flex flex-col w-3/4 rounded border border-gray-300 py-2"
                                    onChange={(event) => orderStatusHandleFunction(currentStatus, event.target.value, orderIndex, order.id)}
                            >
                                {ORDER_STATUS_CONSTANTS.map((status) => (
                                    <option key={status.value} value={status.value}>{status.value}</option>
                                ))}
                            </select>
                        }
                    </div>
                    <div className="w-[25%] flex justify-center items-center bg-[#ebf2f6] border-solid border-r-2 border-b-2 border-white">
                        <div className="flex flex-row w-full justify-evenly text-sm text-[#0d3857]">
                            {currentStatus !== 'Pending' &&
                                <button
                                    type="submit"
                                    onClick={() => orderEditHandleFunction(currentStatus, orderIndex)}
                                    className="p-2 group relative cursor-pointer"
                                    aria-label="Complete Info"
                                >
                                    <IconInformation />
                                    <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Info
                                        </span>
                                </button>
                            }

                            {currentStatus === 'Pending' &&
                                <>
                                    <button
                                        type="submit"
                                        onClick={() => orderEditHandleFunction(currentStatus, orderIndex)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="Order Edit"
                                    >
                                        <IconPen />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Edit
                                        </span>
                                    </button>
                                    <button
                                        type="submit"
                                        onClick={() => navigate(`${SEARCH_SAMPLE_PATH}?orderId=${order.id}`)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="Sample Add"
                                    >
                                        <IconPlus />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Add
                                        </span>
                                    </button>
                                    <button
                                        type="submit"
                                        onClick={() => handleDeleteConfirmModalOpen(order.orderId)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="Order Delete"
                                    >
                                        <IconTrash />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Delete
                                        </span>
                                    </button>
                                    <button
                                        type="submit"
                                        onClick={() => requestOnlyPdfFunction(order.orderId, 1)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="PDF"
                                    >
                                        <IconPdf />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            PDF
                                        </span>
                                    </button>
                                </>
                            }
                            {currentStatus === 'In Production' &&
                                <div>
                                    <input
                                        id="remember-me"
                                        name="pdfUsed"
                                        type="checkbox"
                                        className="h-4 w-4 text-highlight-primary focus:ring-sky-500 border-gray-300 rounded mr-2"
                                        checked={order?.pdfUsed}
                                        onChange={() => pdfUsedHandleFunction(order.orderId, 2)}
                                    />
                                    <button
                                        type="submit"
                                        onClick={() => requestOnlyPdfFunction(order.orderId, 2)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="PDF"
                                    >
                                        <IconPdf />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            PDF
                                        </span>
                                    </button>
                                </div>
                            }
                            {currentStatus === 'Ready For Shipment' &&
                                <button
                                    type="submit"
                                    onClick={() => requestGeneralLabel(order.id)}
                                    className="p-2 group relative cursor-pointer"
                                    aria-label="General Label"
                                >
                                    <IconSampleLabel />
                                    <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                        Label
                                        </span>
                                </button>
                            }

                            {currentStatus === 'Shipping' &&
                                <>
                                    <button
                                        type="submit"
                                        onClick={() => createShipmentLabelFunction(order.id)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="Print Shipment Label"
                                    >
                                        <IconShipment />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Ship
                                        </span>
                                    </button>
                                    <button
                                        type="submit"
                                        onClick={() => createManuelShipmentLabelFunction(order.id)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="Manuel Ship"
                                    >
                                        <IconAddManuel />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Manuel
                                        </span>
                                    </button>
                                    <button
                                        type="submit"
                                        onClick={() => orderStatusHandleFunction(currentStatus, 'Ready For Shipment', orderIndex, order.id)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="Move to Ready for Shipment"
                                    >
                                        <IconBack />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Revert
                                        </span>
                                    </button>
                                </>
                            }

                            {currentStatus === 'Completed' &&
                                <>
                                    <button
                                        type="submit"
                                        onClick={() => requestOnlyPdfFunction(order.orderId, 5)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="PDF"
                                    >
                                        <IconPdf />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            PDF
                                        </span>
                                    </button>
                                    <button
                                        type="submit"
                                        onClick={() => orderStatusHandleFunction(currentStatus, 'Shipping', orderIndex, order.id)}
                                        className="p-2 group relative cursor-pointer"
                                        aria-label="Move to Shipping"
                                    >
                                        <IconBack />
                                        <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-100 absolute bottom-full left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-1 rounded-md">
                                            Revert
                                        </span>
                                    </button>
                                </>
                            }
                        </div>
                    </div>
                </div>
            ))}

            {/* Pagination Controls */}
            <div className="flex flex-row w-full justify-between items-center pt-4">
                <div className="flex w-1/2">
                    Showing {startIndex} to {endIndex} of {dataSize} results
                </div>
                <div className="flex w-1/2 justify-end items-center">
                    <button
                        type="submit"
                        className="px-4 py-2 mx-2 bg-gray-200 rounded disabled:opacity-50"
                        onClick={() => requestDataFunction(currentStatus, -1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span className="px-4 py-2">{currentPage} / {totalPages}</span>
                    <button
                        type="submit"
                        className="px-4 py-2 mx-2 bg-gray-200 rounded disabled:opacity-50"
                        onClick={() => requestDataFunction(currentStatus, 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            {isDeleteModalOpen &&
                <DeleteConfirmModal
                    onClose={() => setIsDeleteModalOpen(false)}
                    open={isDeleteModalOpen}
                    deleteFunction={acceptDelete}
                    data={isDeleteModalData}
                />
            }
        </>
    );
};

DashboardTableData.propTypes = {
    data: PropTypes.array.isRequired,
    orderStatusHandleFunction: PropTypes.func,
    orderDeleteHandleFunction: PropTypes.func,
    orderEditHandleFunction: PropTypes.func,
    createShipmentLabelFunction: PropTypes.func,
    createManuelShipmentLabelFunction: PropTypes.func,
    currentStatus: PropTypes.string.isRequired,
    currentPage: PropTypes.number.isRequired,
    dataSize: PropTypes.number.isRequired,
    requestDataFunction: PropTypes.func.isRequired,
    requestGeneralLabel: PropTypes.func,
    requestOnlyPdfFunction: PropTypes.func,
    pdfUsedHandleFunction: PropTypes.func,
};

DashboardTableData.defaultProps = {
    orderStatusHandleFunction: () => console.log('Default Order Status Handle'),
    orderDeleteHandleFunction: () => console.log('Default Order Delete Handle'),
    orderEditHandleFunction: () => console.log('Default Order Edit Handle'),
    createShipmentLabelFunction: () => console.log('Create Shipment Label Handle'),
    createManuelShipmentLabelFunction: () => console.log('Create Manuel Shipment Label Handle'),
    requestGeneralLabel: () => console.log('General Label Export Function Handle'),
    requestOnlyPdfFunction: () => console.log('Request Only PDF Function Handle'),
    pdfUsedHandleFunction: () => console.log('Request Only PDF Used Function Handle'),
};

export default DashboardTableData;
